module.exports = __webpack_public_path__ + "media/application/images/icons/chevron-right-cda54d9dab79cac733599578a8e4bbbc.svg";